import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import AccessService from '../../service/accessService';
import SessionService from '../../service/sessionService';
import { getAdminKey } from '../../service/adminKeyService';
import AdminPage from './adminPage';

const VALID_SECTIONS = new Set(['sports', 'users', 'activity']);

const AdminPageWrapper = () => {
    const location = useLocation();
    const accessService = AccessService.getInstance();
    const isAdmin = accessService.isAdmin();
    const isAuthenticated = SessionService.getInstance().isAuthenticated();
    const hasAdminKey = Boolean(getAdminKey());
    const requestedSection = new URLSearchParams(location.search).get('section');
    const initialSection = VALID_SECTIONS.has(requestedSection) ? requestedSection : 'sports';

    if (!isAdmin && !isAuthenticated && !hasAdminKey) {
        return <Navigate to="/home" replace />;
    }

    return <AdminPage initialSection={initialSection} />;
};

export default AdminPageWrapper;
